import React from "react";

import "./Cube.css";

function Cube() {
    return (
        <div class="container">
            <div class="cube-one">
                <div class="side front"></div>
                <div class="side left"></div>
                <div class="side right"></div>
                <div class="side back"></div>
                <div class="side top"></div>
                <div class="side bottom"></div>
            </div>
            <div class="cube-two">
                <div class="side front"></div>
                <div class="side left"></div>
                <div class="side right"></div>
                <div class="side back"></div>
                <div class="side top"></div>
                <div class="side bottom"></div>
            </div>
            <div class="cube-three">
                <div class="side front"></div>
                <div class="side left"></div>
                <div class="side right"></div>
                <div class="side back"></div>
                <div class="side top"></div>
                <div class="side bottom"></div>
            </div>
        </div>
    );
}

export default Cube;
